import { render, staticRenderFns } from "./type-detail.vue?vue&type=template&id=1a5f3374&"
import script from "./type-detail.vue?vue&type=script&lang=js&"
export * from "./type-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports